import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import Swal from 'sweetalert2';
import { UserTransferDto } from '../../../interfaces/user-transfer.dto';

declare const bootstrap: any; // Bootstrap 5 modal API

@Component({
  selector: 'transfer-list',
  templateUrl: 'transfer-list.component.html',
  styleUrls: ['transfer-list.component.css'],
})
export class TransferListComponent implements OnInit {
  @Input() transfers: UserTransferDto[] = [];
  @Output() transfersChange = new EventEmitter<UserTransferDto[]>();
  editIndex: number | null = null;
  editedTransfer: UserTransferDto = new UserTransferDto('', 0, '');
  isLoading: boolean = false;

  @ViewChild('transferModalRef') transferModalRef!: ElementRef;

  constructor() {}

  ngOnInit() {
    //
  }

  resetEdition() {
    this.editIndex = null;
    this.editedTransfer = new UserTransferDto('', 0, '');
  }

  closeTransferModal() {
    const modalElement = this.transferModalRef.nativeElement;
    const modalInstance = bootstrap.Modal.getOrCreateInstance(modalElement);
    modalInstance.hide();
  }

  validateEmail(email: string): boolean {
    // Expresión regular simple para validar emails
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  addTransfer() {
    if (
      this.validateEmail(this.editedTransfer.email) &&
      this.editedTransfer.amount > 0
    ) {
      this.transfers.push({ ...this.editedTransfer });
      this.transfersChange.emit(this.transfers); // <-- Notifica el cambio
      this.resetEdition();
      this.closeTransferModal(); // Cierra el modal al guardar
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, introduce un email válido y una cantidad de tokens mayor a 0.',
        icon: 'error',
      });
    }
  }

  editTransfer(index: number) {
    this.editIndex = index;
    this.editedTransfer = { ...this.transfers[index] };
  }

  saveEdit() {
    if (
      this.editIndex !== null &&
      this.validateEmail(this.editedTransfer.email) &&
      this.editedTransfer.amount > 0
    ) {
      this.transfers[this.editIndex] = { ...this.editedTransfer };
      this.transfersChange.emit(this.transfers); // <-- Notifica el cambio
      this.resetEdition();
      this.closeTransferModal(); // Cierra el modal al guardar
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, introduce un email válido y una cantidad de tokens mayor a 0.',
        icon: 'error',
      });
    }
  }

  cancelEdit() {
    this.resetEdition();
  }

  async deleteTransfer(index: number) {
    const confirmResult = await Swal.fire({
      title: 'Confirmar borrado',
      html: `¿Estás seguro de que quieres borrar la inversión de <strong>${this.transfers[index].email}</strong>?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, borrar',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmResult.isConfirmed) {
      return; // Usuario canceló la operación
    }

    this.transfers.splice(index, 1);
    this.transfersChange.emit(this.transfers); // <-- Notifica el cambio
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const text = e.target.result;
      const lines = text
        .split('\n')
        .map((l: string) => l.trim())
        .filter((l: string) => l);
      const newTransfers = [];
      for (const line of lines) {
        const [email, tokens] = line.split(',').map((v: string) => v.trim());
        if (email && tokens && !isNaN(Number(tokens))) {
          newTransfers.push(new UserTransferDto(email, Number(tokens), ''));
        }
      }
      this.transfers = [...newTransfers];
      this.transfersChange.emit(this.transfers); // <-- Notifica el cambio
    };
    reader.readAsText(file);
  }

  saveTransfers() {
    if (this.transfers.length === 0) {
      Swal.fire({
        title: 'No hay inversiones',
        text: 'No hay inversiones para guardar.',
        icon: 'info',
      });
      return;
    }

    const filas = this.transfers
      .map((i) => `${i.email},${i.amount}`)
      .join('\n');
    const contenidoCSV = `${filas}`;

    const blob = new Blob([contenidoCSV], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', 'inversiones.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    Swal.fire({
      title: 'Inversiones guardadas',
      text: 'Las inversiones se han guardado correctamente.',
      icon: 'success',
    });

    this.resetEdition();
    this.closeTransferModal(); // Cierra el modal al guardar
  }

  getErrorMessage(error: string): string {
    if (error === 'no wallet') {
      return '&nbsp;&nbsp;* Sin billetera en Mangopay';
    } else if (error === 'unknown') {
      return '&nbsp;&nbsp;* Usuario desconocido';
    } else return '';
  }
}
